<template>
  <vs-row>
    <vs-col>
      <vs-row class="mb-3 mt-2">
        <h4>Alert</h4>
      </vs-row>

      <div class="table-responsive">
        <vs-table :data="read" style="color: #333f50">
          <template slot="thead">
            <vs-th
              style="padding: 0px"
              v-for="(head, indexh) in list"
              :key="indexh"
            >
              {{ head }}
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ name }}
              </vs-td>
              <vs-td :key="indextd" v-for="(td, indextd) in tr">
                {{ tr[indextd] }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-col>
  </vs-row>
</template>
<script>
export default {
  name: "AlertState",
  props: ["id", "calldata", "nwid", "type"],
  data: () => ({
    alert: [
      { id: 1, alert: "Temp > 27 C", time: "2020-7-15 8:50" },
      { id: 2, alert: "Humidity > 65%", time: "2020-7-15 8:51" },
      { id: 3, alert: "Temp < 24 C", time: "2020-7-15 8:52" },
      { id: 4, alert: "Humidity < 40%", time: "2020-7-15 8:53" },
    ],
    read: [],
    list: [
      "Alert Name",
      "Condition",
      "Sensor Name",
      "Reading Data",
      "Alert Timestamp",
      "Status",
    ],
    dataform: {
      data: "",
      date: 0,
    },
  }),
  methods: {
    linkpage() {
      this.$router.push({
        name: "SensorPage",
        params: {
          data: this.read,
          calldata: this.calldata,
          sensorid: this.id,
          nwid: this.nwid,
        },
      });
    },
  },
  created() {
    switch (this.type) {
      case "powermeter":
        for (let i = 0; i < this.calldata.length; i++) {
          this.read[i] = JSON.parse(JSON.stringify(this.calldata[i]));
        }
        break;
      case "monnit":
        for (let i = 0; i < this.calldata.length; i++) {
          this.read[i] = JSON.parse(JSON.stringify(this.calldata[i]));
        }
        break;
    }
  },
};
</script>
<style scoped>
.wrapper.overflow {
  overflow-y: scroll;
  max-height: 250px;
}
</style>

